import { useQuery } from 'react-query';

import { getTrapDetailPieEntriesChartData } from 'api/traps/Trap/getTrapDetailPieEntriesChartData';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const useGetTrapDetailPieEntriesChartData = (slug: string, type: TrapType) => {
  const { data, isLoading, isFetching } = useQuery(
    ['TrapDetailPieEntriesChartData', slug, type],
    () => getTrapDetailPieEntriesChartData(slug, type),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, isLoading, isFetching };
};
